if (!customElements.get('promotions-messaging')) {
  class ComponentPromotionsMessaging extends HTMLElement {
    constructor() {
        super()
        this.url = this.dataset.url;
        this.disableCollections = this.dataset.disableCollections === 'true'
        this.disablePriceAdjustment = this.dataset.disablePriceAdjustment === 'true'
        this.loadPromotions()
    }

    async loadPromotions () {
      const response = await fetch(`${this.url}?section_id=product_promos`);
      if (!response) return;
      const stringHtml = await response.text();

      const htmlPromos = new DOMParser().parseFromString(stringHtml, 'text/html')
      if(!htmlPromos) return null;

      const productPromosHtml = htmlPromos.querySelector('.product-promos .product-promo');
      const collectionPromosHtml = htmlPromos.querySelector('.product-promos .collection-promo')

      if (this.disableCollections && collectionPromosHtml) return;

      if (productPromosHtml || collectionPromosHtml) {
        this.appendChild(htmlPromos.querySelector('.product-promos'))
        if (collectionPromosHtml && !this.disablePriceAdjustment) {
          var pricesEl = this.parentNode.querySelectorAll('.price')
          pricesEl.forEach(priceEl => priceEl.querySelector('.final')?.classList.add('compare', 'offer'))
        }
      } else {
        this.classList.add('hide')
      }
    }
  }
  customElements.define('promotions-messaging', ComponentPromotionsMessaging);
}